// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__ykugn","spaceBlock":"style_spaceBlock__xc2M4"};